module.exports = __webpack_public_path__ + "static/media/wolf-pack-battalion.f1f12797.svg";